import { Link } from "react-router-dom";
import { Heart, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from "lucide-react";

const Logo = () => (
  <img 
    src="https://customer-assets.emergentagent.com/job_tulsa-student-care/artifacts/ly6w2llm_Screenshot%202026-02-13%20at%204%2C17%2C27%E2%80%AFPM-Picsart-BackgroundRemover%20%281%29.png"
    alt="Comforts of Home Logo"
    className="w-12 h-12 object-contain"
  />
);

const Footer = () => {
  return (
    <footer className="bg-[rgba(212,230,240,1)] text-[#3F4A52] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <Logo />
              <div className="flex items-baseline gap-1">
                <span className="font-heading text-lg text-[#3F4A52]">Comforts</span>
                <span className="font-accent text-xl text-[#3F4A52]">of Home</span>
              </div>
            </div>
            <p className="font-body text-sm text-[#6F7F8C] leading-relaxed">
              Sending love and comfort to college students in Tulsa, one care package at a time.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="font-body text-sm text-[#6F7F8C] hover:text-[#3F4A52] transition-colors">Home</Link>
              <Link to="/about" className="font-body text-sm text-[#6F7F8C] hover:text-[#3F4A52] transition-colors">About Us</Link>
              <Link to="/shop" className="font-body text-sm text-[#6F7F8C] hover:text-[#3F4A52] transition-colors">Shop</Link>
              <Link to="/cart" className="font-body text-sm text-[#6F7F8C] hover:text-[#3F4A52] transition-colors">Cart</Link>
              <Link to="/contact" className="font-body text-sm text-[#6F7F8C] hover:text-[#3F4A52] transition-colors">Contact</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg mb-4">Contact</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm text-[#6F7F8C]">
                <Mail size={16} />
                <a href="mailto:comfortsofhometulsa@gmail.com" className="hover:text-[#3F4A52] transition-colors">
                  comfortsofhometulsa@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#6F7F8C]">
                <Phone size={16} />
                <a href="tel:9186093851" className="hover:text-[#3F4A52] transition-colors">(918) 609-3851</a>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#6F7F8C]">
                <MapPin size={16} />
                <span>Tulsa, Oklahoma</span>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-heading text-lg mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-[#9FBFD6]/50 rounded-full hover:bg-brand-coral transition-colors" aria-label="Facebook" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="p-2 bg-[#9FBFD6]/50 rounded-full hover:bg-brand-coral transition-colors" aria-label="Instagram" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="p-2 bg-[#9FBFD6]/50 rounded-full hover:bg-brand-coral transition-colors" aria-label="Twitter" data-testid="social-twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#9FBFD6]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-sm text-[#6F7F8C]">
              © 2024 Comforts of Home Tulsa. All rights reserved.
            </p>
            <p className="font-body text-sm text-[#6F7F8C] flex items-center gap-1">
              Made with <Heart size={14} className="text-brand-coral" /> in Tulsa, OK
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
